module.exports = __webpack_public_path__ + "img/saoma.97afb612.png";